/** First-party adapter for the host's validated, click-only navigation event. */
export function installAgentNavigation(options: {
  origin: string;
  navigate: (href: string) => unknown;
  onError: () => void;
  target?: EventTarget;
}): () => void {
  const target = options.target ?? window;
  const receive = (event: Event) => {
    if (!(event instanceof CustomEvent) || !event.cancelable || event.defaultPrevented) return;
    const value: unknown = event.detail;
    if (!value || typeof value !== "object" || Array.isArray(value)) return;
    const data = value as Record<string, unknown>;
    if (
      Object.keys(data).sort().join(",") !== "integration,path,version" ||
      data.version !== 1 ||
      typeof data.integration !== "string" ||
      !/^[A-Za-z0-9][A-Za-z0-9_-]{0,127}$/.test(data.integration) ||
      typeof data.path !== "string" ||
      data.path.length > 2048 ||
      new TextEncoder().encode(data.path).byteLength > 2048 ||
      !data.path.startsWith("/") ||
      data.path.startsWith("//") ||
      data.path.includes("\\") ||
      Array.from(data.path).some((c) => c.charCodeAt(0) < 32 || c.charCodeAt(0) === 127) ||
      /%(?:0[0-9a-f]|1[0-9a-f]|7f)/i.test(data.path)
    )
      return;
    try {
      const url = new URL(data.path, options.origin);
      if (url.origin !== options.origin || url.pathname + url.search + url.hash !== data.path)
        return;
    } catch {
      return;
    }
    event.preventDefault();
    try {
      void Promise.resolve(options.navigate(data.path)).catch(options.onError);
    } catch {
      options.onError();
    }
  };
  target.addEventListener("agentserver:navigate", receive);
  return () => target.removeEventListener("agentserver:navigate", receive);
}
